"use strict";
export class Quote {
    _nameEn: string;
    _nameAr: string;
    _reuter: string;
    _id: number;
    _currency: number;
    _name: string;
    _nameArabic: string;
    _isinCode: string;
    _sectorEn: string;
    _sectorAr: string;
    _indicesList: Array<string>;
    _type: number;
    _status: number;
    _marketCode: string;
    _last: number = 0.00;
    _vwap: number = 0.00;
    _change: number = 0.00;
    _changePercentage: number = 0.00;
    _high: number = 0.00;
    _low: number = 0.00;
    _open: number = 0.00;
    _totalBids: number = 0;
    _totalAsks: number = 0;
    _hBid: number = 0.00;
    _lAsk: number = 0.00;
    _turnover: number = 0;
    _volume: number = 0;
    _news: string = "";
    _firstTade: number = 0.00;
    _lastUpdateTime: string = "";
    _noOfTrades: number = 0;
    _baSpread: number = 0.00;
    _refPrice: number = 0.00;
    _sdtValue: number = 0;
    _sdtPercentage: number = 0.00;
    _isin: string = "";
    _sdtLimit: number = 0.00;
    _priceLimit: string = "";
    _preVwap: number = 0.00;
    _vwapChange: number = 0.00;
    _vwapChangePercentage: number = 0.00;
    _52Low: number = 0.00;
    _52High: number = 0.00;
    _listedShares: number = 0

    constructor(nameEn: string = null, nameAr: string = null,
        reu: string = null, id: number = 0, cur: number = 1, code: string = null,
        sectorEn: string = null, sectorAr: string = null, indicesList: Array<string> = null,
        type: number = null, status: number = null, marketCode: string = null, listedShares: number = 0) {
        this._nameEn = nameEn;
        this._nameAr = nameAr
        this._reuter = reu;
        this._id = id;
        this._currency = cur;
        this._isinCode = code;
        this._sectorEn = sectorEn;
        this._sectorAr = sectorAr;
        this._indicesList = indicesList;
        this._type = type;
        this._status = status;
        this._marketCode = marketCode;
        this._name = reu + " " + nameEn;
        this._nameArabic = reu + " " + nameAr;
        this._listedShares = listedShares;
    }

    isEGXIndexOf(index: string): boolean {
        let i = this._indicesList.findIndex(e => (e == index));
        return (i >= 0) ? true : false;
    }

    public get nameEn(): string { return this._nameEn; }
    public set nameEn(val: string) { this._nameEn = val; }

    public get nameAr(): string { return this._nameAr; }
    public set nameAr(val: string) { this._nameAr = val; }

    public get reuter(): string { return this._reuter; }
    public set reuter(val: string) { this._reuter = val; }

    public get id(): number { return this._id; }
    public set id(val: number) { this._id = val; }

    public get currency(): number { return this._currency; }
    public set currency(val: number) { this._currency = val; }

    get code(): string { return this._isinCode; }
    set code(val: string) { this._isinCode = val; }

    get sectorEn(): string { return this._sectorEn; }
    set sectorEn(val: string) { this._sectorEn = val; }

    get sectorAr(): string { return this._sectorAr; }
    set sectorAr(val: string) { this._sectorAr = val; }

    get indicesList(): Array<string> { return this._indicesList; }
    set indicesList(val: Array<string>) { this._indicesList = val; }

    get type(): number { return this._type; }
    set type(val: number) { this._type = val; }

    get status(): number { return this._status; }
    set status(val: number) { this._status = val; }

    get marketCode(): string { return this._marketCode; }
    set marketCode(val: string) { this._marketCode = val; }

    get name(): string { return this._name; }
    set name(val: string) { this._name = val; }

    get nameArabic(): string { return this._nameArabic; }
    set nameArabic(val: string) { this._nameArabic = val; }

    get last(): number { return this._last; }
    set last(val: number) { this._last = val; }

    get vwap(): number { return this._vwap; }
    set vwap(val: number) { this._vwap = val; }

    get change(): number { return this._change; }
    set change(val: number) { this._change = val; }

    get changePercentage(): number { return this._changePercentage; }
    set changePercentage(val: number) { this._changePercentage = val; }

    get high(): number { return this._high; }
    set high(val: number) { this._high = val; }

    get low(): number { return this._low; }
    set low(val: number) { this._low = val; }

    get open(): number { return this._open; }
    set open(val: number) { this._open = val; }

    get totalBids(): number { return this._totalBids; }
    set totalBids(val: number) { this._totalBids = val; }

    get totalAsks(): number { return this._totalAsks; }
    set totalAsks(val: number) { this._totalAsks = val; }

    get hBid(): number { return this._hBid; }
    set hBid(val: number) { this._hBid = val; }

    get lAsk(): number { return this._lAsk; }
    set lAsk(val: number) { this._lAsk = val; }

    get turnover(): number { return this._turnover; }
    set turnover(val: number) { this._turnover = val; }

    get volume(): number { return this._volume; }
    set volume(val: number) { this._volume = val; }

    get news(): string { return this._news; }
    set news(val: string) { this._news = val; }

    get firstTade(): number { return this._firstTade; }
    set firstTade(val: number) { this._firstTade = val; }

    get lastUpdateTime(): string { return this._lastUpdateTime; }
    set lastUpdateTime(val: string) { this._lastUpdateTime = val; }

    get noOfTrades(): number { return this._noOfTrades; }
    set noOfTrades(val: number) { this._noOfTrades = val; }

    get baSpread(): number { return this._baSpread; }
    set baSpread(val: number) { this._baSpread = val; }

    get refPrice(): number { return this._refPrice; }
    set refPrice(val: number) { this._refPrice = val; }

    get sdtValue(): number { return this._sdtValue; }
    set sdtValue(val: number) { this._sdtValue = val; }

    get sdtPercentage(): number { return this._sdtPercentage; }
    set sdtPercentage(val: number) { this._sdtPercentage = val; }

    get sdtLimit(): number { return this._sdtLimit; }
    set sdtLimit(val: number) { this._sdtLimit = val; }

    get priceLimit(): string { return this._priceLimit; }
    set priceLimit(val: string) { this._priceLimit = val; }

    get preVwap(): number { return this._preVwap; }
    set preVwap(val: number) { this._preVwap = val; }

    get vwapChange(): number { return this._vwapChange; }
    set vwapChange(val: number) { this._vwapChange = val; }

    get vwapChangePercentage(): number { return this._vwapChangePercentage; }
    set vwapChangePercentage(val: number) { this._vwapChangePercentage = val; }

    get yearLow(): number { return this._52Low; }
    set yearLow(val: number) { this._52Low = val; }

    get yearHigh(): number { return this._52High; }
    set yearHigh(val: number) { this._52High = val; }

    get listedShares(): number { return this._listedShares; }
    set listedShares(val: number) { this._listedShares = val; }

}